import type { CustomDropdownItemComponentProps } from "common/components/dropdown/Dropdown";
import { DropdownItem } from "common/components/dropdown/DropdownItem";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { fetchTopicPresentation } from "domains/topic/actions";
import { getIsPresentationDownloading } from "domains/topic/selectors";
import { StyledLoadingIndicator } from "domains/topicDetail/components/advancedOptions/LoadingIndicator";
import { useEffectAfterFirstRender } from "domains/topicDetail/components/advancedOptions/useEffectAfterFirstRender";
import { getTmTopic } from "domains/transformationMap/selectors";

export const TopicPresentationOptionsButton = ({
  handleDeactivate,
  index,
  isActive,
}: CustomDropdownItemComponentProps) => {
  const dispatch = useDispatch();
  const topic = useSelector(getTmTopic);
  const isPresentationDownloading = useSelector(getIsPresentationDownloading);
  const track = useTrack();
  const translate = useTranslate();

  const exportPresentation = () => {
    if (!topic) {
      return;
    }
    track({
      entityId: topic.id,
      entityName: topic.name,
      entityType: "Topic",
      name: "Map Presentation Export",
      page: "Topic detail",
    });
    dispatch(fetchTopicPresentation({ id: topic.id, name: topic.name }));
  };

  useEffectAfterFirstRender(() => {
    if (!isPresentationDownloading) {
      handleDeactivate();
    }
  }, [isPresentationDownloading]);

  return (
    <DropdownItem
      index={index}
      isActive={isActive}
      isDisabled={isPresentationDownloading}
      isProItem
      onClick={exportPresentation}
    >
      {translate("app.topic.presentation_export")}
      {isPresentationDownloading && <StyledLoadingIndicator />}
    </DropdownItem>
  );
};
